import { RoleName } from '../../types/user';

export const organisationRoles = [
	RoleName.OrgnaisationAdmin,
	RoleName.Registrar,
	RoleName.VerifierOnlyOrg,
	RoleName.FamilyOrganisationAdmin
];
